

import { FC, PropsWithChildren, ReactNode } from 'react';

import { Stack, Text } from '@eneco/sparky';
import { ElectricityIcon, GasIcon, RedeliveryIcon, WarmthIcon, WaterIcon } from '@eneco/sparky/icons';
import { DC_Repositories_Base_Enumerations_Label } from '@monorepo-types/dc';

import { DetailsType } from '../../types';

interface Props {
  theme?: DC_Repositories_Base_Enumerations_Label;
  type: DetailsType;
  title?: string;
}

export const ConsumptionDetails: FC<PropsWithChildren<Props>> = ({ theme, type, title, children }) => {
  let icon: ReactNode;

  switch (type) {
    case DetailsType.Gas:
      icon = <GasIcon color={theme === 'oxxio' ? 'iconTertiary' : 'iconGas'} />;
      break;

    case DetailsType.Water:
      icon = <WaterIcon color={theme === 'oxxio' ? 'iconTertiary' : 'iconCooling'} />;
      break;

    case DetailsType.Electricity:
      icon = <ElectricityIcon color={theme === 'oxxio' ? 'iconTertiary' : 'iconElectricity'} />;
      break;

    case DetailsType.Warmth:
      icon = <WarmthIcon color={theme === 'oxxio' ? 'iconTertiary' : 'iconHeat'} />;
      break;

    default:
      icon = <RedeliveryIcon color={theme === 'oxxio' ? 'iconTertiary' : 'iconSolar'} />;
  }

  return (
    <Stack direction="row" alignY="center" gap="1">
      {icon}

      <Text size="BodyXS">
        {title && <Text weight="bold">{title} </Text>}
        {children}
      </Text>
    </Stack>
  );
};
